import { jsxs as i, jsx as u } from "react/jsx-runtime";
import { useState as T, useEffect as j } from "react";
import o from "./styles.module.less.js";
import { QuestionWrapper as x } from "../index.js";
import A from "./add-icon.svg.js";
import D from "./remove-icon.svg.js";
import { QuestionType as q } from "@law-connect/types";
const K = (C) => {
  var h, I, y;
  const {
    questions: $,
    question: r,
    onChange: d,
    disabled: f = !1,
    language: N,
    getTranslation: c,
    errors: Q
  } = C, m = (n, e) => {
    for (const t of e) {
      if (t.id === n)
        return t;
      if (t.type === q.MultiPart) {
        const a = m(n, t.questions);
        if (a)
          return a;
      }
      if (t.type === q.Items && t.answer)
        for (const a of t.answer) {
          const s = m(n, a);
          if (s)
            return s;
        }
    }
    return null;
  }, [b, p] = T(0), g = (n) => (e) => {
    e.preventDefault(), p(n);
  }, w = (n) => {
    n.stopPropagation(), n.preventDefault();
    const e = {
      ...r,
      answer: [
        ...r.answer || [],
        r.questions
      ]
    };
    d(e), p(
      e.answer && e.answer.length > 0 ? e.answer.length - 1 : 0
    );
  }, k = (n) => (e) => {
    var a;
    e.stopPropagation(), e.preventDefault();
    const t = {
      ...r,
      answer: (a = r.answer) == null ? void 0 : a.filter(
        (s, l) => l !== n
      )
    };
    d(t), p(n - 1 > 0 ? n - 1 : 0);
  }, P = (n) => (e) => {
    const t = { ...r, answer: r.answer ? [...r.answer] : void 0 };
    t.answer && t.answer[n] && (t.answer[n] = t.answer[n].map((a) => a.id === e.id ? e : a)), d(t);
  };
  return j(() => {
    r.answer || w(new MouseEvent("click"));
  }, []), /* @__PURE__ */ i("div", { className: o.tabList, children: [
    /* @__PURE__ */ i("div", { className: o.tabItems, children: [
      (h = r.answer) == null ? void 0 : h.map((n, e) => {
        var a;
        const t = (a = n.find((s) => s.id === r.label)) == null ? void 0 : a.answer;
        return console.log("qAnswer", t, r.label), /* @__PURE__ */ u(
          "button",
          {
            onClick: g(e),
            className: `${o.tabItem} ${e === b ? o.active : ""}`,
            children: r.label && t && typeof t != "object" ? t || c("prematter.new") : r.label ? `${r.label} #${e + 1}` : `#${e + 1}`
          },
          e
        );
      }),
      /* @__PURE__ */ i("button", { onClick: w, className: o.tabAdd, disabled: f, children: [
        /* @__PURE__ */ u(A, {}),
        " ",
        c("prematter.add")
      ] })
    ] }),
    (I = r.answer) == null ? void 0 : I.map((n, e) => /* @__PURE__ */ i(
      "div",
      {
        className: `${o.tab} ${e === b ? o.active : ""}`,
        children: [
          n.map((t, a) => {
            if (t.onlyAvailableIf) {
              const s = t.onlyAvailableIf;
              let l = m(
                s.questionId,
                n
              );
              if (l || (l = m(
                s.questionId,
                $
              )), l) {
                let v = !1;
                if (Array.isArray(s.answer) ? v = s.answer.includes(
                  l.answer
                ) : v = l.answer === (s == null ? void 0 : s.answer), !v)
                  return null;
              }
            }
            return /* @__PURE__ */ u(
              x,
              {
                questions: $,
                question: t,
                onChange: P(e),
                disabled: f,
                language: N,
                getTranslation: c,
                namePrefix: `tab-${e}`,
                errors: Q,
                errorKeyPrefix: `${r.id}-${e}-`
              },
              a
            );
          }),
          /* @__PURE__ */ i("button", { onClick: k(e), className: o.tabRemove, children: [
            /* @__PURE__ */ u(D, {}),
            " ",
            c("prematter.remove")
          ] })
        ]
      },
      e
    )),
    /* @__PURE__ */ i("div", { className: o.tabItems, children: [
      (y = r.answer) == null ? void 0 : y.map((n, e) => {
        var a;
        const t = (a = n.find((s) => s.id === r.label)) == null ? void 0 : a.answer;
        return /* @__PURE__ */ u(
          "button",
          {
            onClick: g(e),
            className: `${o.tabItem} ${o.reverse} ${e === b ? o.active : ""}`,
            children: r.label && t && typeof t != "object" ? t || c("prematter.new") : r.label ? `${r.label} #${e + 1}` : `#${e + 1}`
          },
          e
        );
      }),
      /* @__PURE__ */ i("button", { onClick: w, className: o.tabAdd, disabled: f, children: [
        /* @__PURE__ */ u(A, {}),
        " ",
        c("prematter.add")
      ] })
    ] })
  ] });
};
export {
  K as QuestionTabList
};
